import { render, staticRenderFns } from "./CoozzyForwardIcon.vue?vue&type=template&id=433f09ce&scoped=true"
import script from "./CoozzyForwardIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyForwardIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyForwardIcon.vue?vue&type=style&index=0&id=433f09ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f09ce",
  null
  
)

export default component.exports